import * as React from "react";
import { Container } from "../../Container";
import { ListStore } from "../../flux/Grid/ListStore";
import { Polyglot } from "../../../polyglot";

interface Props
{
    polyglot: Polyglot;
    listStore: ListStore<any>;
}

export class NoResults extends React.Component<Props, any>
{
    render()
    {
        const { polyglot, listStore } = this.props;
        return <Container subscribe={[listStore]} render={() => listStore.getItemsCount() === 0 ? <span>{polyglot.t('misc.no_results')}</span> : null } />
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Table/NoResults.tsx